import { uploadFile } from "@/services/upload.service";
import type { CreateCommentInput } from "./types";

export class CommentsUploadClient {
	constructor(private readonly projectId?: string) {}

	async upload(file: File): Promise<{
		success: boolean;
		attachment?: NonNullable<CreateCommentInput["attachment"]>;
		error?: string;
	}> {
		const result = await uploadFile(file, {
			folder: "comments",
			entityType: "projects",
			entityId: this.projectId,
		});
		if (!result.success || !result.url) {
			return { success: false, error: result.error || "Failed to upload file" };
		}

		return {
			success: true,
			attachment: {
				url: result.url,
				filename: file.name,
				mimeType: file.type,
				size: file.size,
			},
		};
	}
}
